'use client';

import React from 'react';
import Icon from '@/components/icon/Icon';
import { Button } from '@/components/button/Button';
import { useTranslations } from '@/lib/locale-context';

type Props = {
  onClose: () => void;
  modalTitle?: string | null;
  modalDescription?: string | null;
};

const SuccessState: React.FC<Props> = ({
  onClose,
  modalTitle,
  modalDescription,
}) => {
  const { t } = useTranslations();
  const title = modalTitle || t('gatewayForms.success.title');
  const description = modalDescription || t('gatewayForms.success.description');
  const closeLabel = t('gatewayForms.success.close');

  return (
    <div className="mx-auto flex w-full max-w-md flex-col items-center px-4 text-center sm:px-6">
      <div className="mb-5 flex h-[48px] w-[48px] items-center justify-center rounded-full bg-emerald-500">
        <Icon name="check" color="#ffffff" size="24px" strokeWidth={3} />
      </div>

      <h2 className="text-[28px] font-medium leading-tight text-[#1A1B25] sm:text-[32px]">
        {title}
      </h2>

      <p className="mt-3 max-w-[32rem] text-[14px] leading-6 text-[#666D80]">
        {description}
      </p>

      <Button
        variant="primary"
        name={closeLabel}
        className="mt-6 w-full justify-center sm:w-fit"
        onClick={onClose}
      >
        {closeLabel}
      </Button>
    </div>
  );
};

export default SuccessState;
